const Form006TC = {
    stepName: {
        basicInfo: "基礎資訊",
        activityList: "活動資訊",
        adjustmentDetail: "修訂詳情",
        adjustmentForm: "修訂資料及預算",
        signature: "簽署頁面",
        confirm: "確認",
    },
    notes: {
        notesTitle: "個人資料收集聲明",
        notes: "註",
        // notesTitle: "聲明",
        // tips1: "1. 電子表格所載的資料均以教育局網頁上之表格為準",
        // tipsUrl:
        //     "https://www.edb.gov.hk/tc/student-parents/support-subsidies/after-sch-learning-support-program/community-based-projects/index.html",
        // tips2: "2. 如參與計劃的合資格學生人數、活動節數和組別數目等有所減少，則相關活動的津貼額將會按減少的比例作調整；如增加上述項目的數額，其支出不能超逾相關計劃已審批的津貼額。任何超逾撥款額的開支，須由機構自行承擔。",
        // tips3: "3. 請填寫計劃活動修訂表（附件）連同該活動的獲批核申請表副本及本申請表一併遞交，並<b><u>待本局批准上述有關修訂後才可執行</u></b>。原則上，由機構交齊所需文件至本局發出批核信，需時約<b><u>十個工作天</u></b>。此外，所有修訂計劃申請必須於<b><u>該學年的5月31日或之前</u></b>送交延伸支援計劃組辦理，本局不會受理逾期的申請。",
        agreeTips: "我已閱讀、理解並同意上述條款和條件。",
        labelTips1:
            "與學校協商後所作的修訂，請學校提供相關文件，如由學校致機構的電郵",
        labelTips2:
            "如︰活動節數由10節減少至9節，受惠合資格學生人數由100人增加至120人等",
    },
    serial: {
        tips1: "（ⅰ）",
        tips2: "（ⅱ）",
        tips3: "（ⅲ）",
    },
    label: {
        info: {
            placeholder: "請輸入...",
        },
        activityName: "活動名稱",
        basicInfoOption: {
            referenceNo: "計劃編號",
            organisationName: "機構名稱",
            projectTitle: "計劃名稱",
            title: "簽署信息",
            coordinatorTitle: "計劃統籌員稱謂",
            coordinatorName: "計劃統籌員姓名",
            contactTitle: "聯絡人稱謂",
            contactName: "聯絡人姓名",
            contactTel: "聯絡電話",
            faxNo: "傳真號碼",
            date: "日期",
        },
        adjustmentDetailOption: {
            title: "修訂詳情",
            projectType: "修訂／取消／新增",
            activityName: "活動名稱",
            collaboratingSchoolName: "協作學校名稱（如適用）",
            schoolSupportingFile: "學校證明文件",
            adjustmentItem: "修訂事項",
            revisedReason: "修訂原因",
            cancelledReason: "取消原因",
            addedReason: "新增原因",
            revisedParticulars: "修訂細節",
            cancelledParticulars: "取消細節",
            addedParticulars: "新增細節",
            others: "其他（請註明）",
        },
        adjustmentFormOption: {
            referenceNo: "計劃編號",
            projectType: "修訂／取消／新增",
            activityName: "活動名稱",
            collaboratingSchoolName: "協作學校名稱（如適用）",
            activityType: "活動性質",
            activityTypeA: "A類",
            activityTypeB: "B類",
            activityTypeC: "C類",
            brieflyDescribe: "請簡述活動目的、內容及評估成效方法等",
            brieflyDescribeMsg: "簡述",
            studentNumber: "估計受惠合資格學生人數（人頭）：",
            primarySchool: "小學（總人數）",
            secondarySchool: "中學（總人數）",
            NCSStudent: "非華語學生",
            SENStudent: "特殊教育需要學生",
            NACStudent: "新來港學童",
            startDate: "開始日期",
            endDate: "結束日期",
            ofGroupNumber: "組別數目",
            tutorStudentRatio: "導師 : 學生比例",
            tutor: "導師",
            student: "學生",
            groupActivities: "每組活動包括：",
            lesson: "課堂",
            session: "每節",
            venue: "地點",
            halfDayActivity: "半日活動",
            wholeDayActivity: "全日活動",
            lessonUnit: "節",
            sessionUnit: "小時",
            halfWholeUnit: "次",
            halfDayTips: "不少於四小時",
            wholeDayTips: "不少於七小時",
        },
        activityBudgetOption: {
            title: "活動的預算項目",
            thTips: "(如有修訂，請提供報價／參考資料)",
            personUnit: "人數",
            pleaseSpecify: "請註明身份：",
            othersPleaseSpecify: "請註明：",
            expenditureItems: "開支項目",
            budgetOfApproved: "已獲批活動預算",
            budgetOfApprovedUnit: "(新增活動<u>不用</u>填此欄)",
            budgetOfRevised: "建議{{projectType}}活動預算",
            projectType: "修訂／新增*",
            budgetOfRevisedUnit: "(取消活動不用填此欄)",
            remarks: "備註",
            academicQualifications: "學歷",
            remarksUnit: "如屬A類–學習技巧，請填寫導師學歷",
        },
        chopAttachment: "非政府機構／附屬機構印鑑",
    },
    table: {
        activityBudget: {
            tutorFee: "導師",
            socialWorkerFee: "社工",
            othersProfession: "其他",
            materialExpenses: "活動物資",
            campAdmissionFee: "營費／入場費",
            studentMeal: "學生膳食（只限全日外出活動）",
            activityTransportationFee: "活動交通費",
            volunteersAllowance: "義工津貼",
            others: "其他",
            totalExpenditure: "總開支",
        },
    },
    select: {
        projectType: {
            revised: "修訂",
            cancelled: "取消",
            added: "新增",
        },
        titleOption: {
            Mr: "先生",
            Ms: "小姐",
            Miss: "女士",
        },
        adjustmentItemAll: {
            studentNo: "受惠合資格學生人數",
            changeGroups: "增減組別數目",
            changeSessions: "增減活動節數",
            changeHours: "增減活動時數",
            adjustBudget: "修訂活動預算",
            changeName: "更改活動名稱",
            changeContent: "更改活動內容（包括地點）",
            others: "其他（請註明）",
            cancelActivity: "取消活動",
            addNewActivity: "新增活動",
        },
        adjustmentItem: {
            revised: {
                studentNo: "受惠合資格學生人數",
                changeGroups: "增減組別數目",
                changeSessions: "增減活動節數",
                changeHours: "增減活動時數",
                adjustBudget: "修訂活動預算",
                changeName: "更改活動名稱",
                changeContent: "更改活動內容（包括地點）",
                others: "其他（請註明）",
            },
            cancelled: {
                cancelActivity: "取消活動",
            },
            added: {
                addNewActivity: "新增活動",
            },
        },
        activityType: {
            tutorialService: "功課輔導",
            learningSkillsTraining: "學習技巧訓練",
            languageTraining: "語文訓練",
            artCulturalActivities: "文化藝術",
            visitsOutdoorActivities: "參觀／戶外活動",
            sportsActivities: "體育活動",
            voluntaryService: "義工服務",
            selfConfidenceDevelopment: "自信心訓練",
            adventureActivities: "歷奇活動",
            socialCommunicationSkills: "社交／溝通技巧訓練",
            leadershipTraining: "領袖訓練",
        },
        activityTypeOption: {
            A: {
                tutorialService: "功課輔導",
                learningSkillsTraining: "學習技巧訓練",
                languageTraining: "語文訓練",
            },
            B: {
                artCulturalActivities: "文化藝術",
                visitsOutdoorActivities: "參觀／戶外活動",
                sportsActivities: "體育活動",
            },
            C: {
                voluntaryService: "義工服務",
                socialCommunicationSkills: "社交／溝通技巧訓練",
                selfConfidenceDevelopment: "自信心訓練",
                leadershipTraining: "領袖訓練",
                adventureActivities: "歷奇活動",
            },
        },
        positionType: {
            types1: "中六畢業（在香港中學文憑考試取得五科達2級或以上，包括中英數）\n中五畢業（在香港中學會考取得五科合格或以上，包括中英數）",
            types2: "中七畢業（在香港高級程度會考取得中、英及2AL／1AL+2AS合格）\n中六畢業（在香港中學文憑考試取得五科達3級或以上，包括中英數）",
            types3: "大專畢業（高級文憑／副學士）",
            types4: "大學畢業（學士學位）或以上",
            types5: "大學畢業（學士學位，主修中文科目）或以上",
            types6: "大學畢業（學士學位，主修英文科目）或以上",
            types7: "大學畢業（學士學位，主修數學科目）或以上",
        },
    },
    errorMsg: {
        numberBetween: "請輸入{{number}}之間的整數",
        betweenThisDate: "請輸入在{{dateBetween}}之間的日期",
        acdamicYear: "請選擇同一學年範圍內的日期",
        othersSpecify: "請輸入一個有效的項目",
        budget: "請輸入一個有效的預算",
        studentTotal: "此項必須小於或等於{{fieldName}}",
        number: {
            min: "此列總和必須大於0",
        },
    },
    comma: "，",
    semicolon: "；",
};
export default Form006TC;
